import React from 'react';
import PropTypes from 'prop-types';
import {ListItem, ListItemText} from '@material-ui/core';

interface NotificationItemProps {
  summary: string;
  hash: string;
  listStyle: string;
}

const TransactionItem: React.FC<NotificationItemProps> = ({
  summary,
  hash,
  listStyle,
}) => {
  return (
    <ListItem
      button
      component='a'
      target='_blank'
      href={process.env.REACT_APP_ETHERSCAN_BASE_URL + '/tx/' + hash}
      className={listStyle}>
      <ListItemText primary={summary} />
    </ListItem>
  );
};

export default TransactionItem;

TransactionItem.propTypes = {
  summary: PropTypes.string.isRequired,
};
